import { 
	faCalendarDays as fasCalendarDays
 } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import { validDate } from "bm-ui-kit";
import type { InputHTMLAttributes } from "react";
import React from "react";
import type { FieldRenderProps } from "react-final-form";
import type { FormInputProps } from "./FormInput";
import { FormInput } from "./FormInput";

export type FormDateProps = FormInputProps;

export class FormDate extends FormInput {
	public static defaultProps: Partial<FormDateProps> = {
		type: "date",
		placeholder: "éééé-hh-nn",
		prepend: <FontAwesomeIcon icon={fasCalendarDays} />,
		maxLength: 10,
	};

	@autobind
	protected parse(value: string): string {
		if (value === undefined) {
			return "";
		}

		return value.replace(/\D+/g, "-");
	}

	@autobind
	protected handleValidate(value: string, allValues: Record<string, any>): string {
		const { required } = this.props;

		if (!this.isDisabled() && value) {
			const valid = validDate(value, required);

			if (valid !== null) {
				return valid;
			}
		}

		return super.handleValidate(value, allValues);
	}

	@autobind
	protected format(value: string): string {
		return this.parse(value);
	}

	protected getInputProps(fieldProps: FieldRenderProps<string>): InputHTMLAttributes<HTMLInputElement> {
		return {
			...super.getInputProps(fieldProps),
			min: "1000-01-01",
			max: "2999-12-31",
		};
	}
}
